import { CheckboxField } from '@cian/components';
import * as React from 'react';
import { EFacility } from '../../../../../../../json_query';
import { InlineParam } from '../../../markup';

export interface ILivingTermsProps {
  facilities: EFacility[];
  onFacilityChanged(param: EFacility, value: boolean): void;
}

interface IFacility {
  name: string;
  type: EFacility;
}

const FACILITIES: IFacility[] = [
  { name: 'Можно с детьми', type: EFacility.KidsAllowed },
  { name: 'Можно с животными', type: EFacility.PetsAllowed },
];

export const LivingTermsComponent: React.StatelessComponent<ILivingTermsProps> = props => (
  <>
    {FACILITIES.map(facility => (
      <InlineParam key={`facility_${facility.name}`}>
        <CheckboxField
          onValueChange={value => props.onFacilityChanged(facility.type, value)}
          value={props.facilities.includes(facility.type)}
          label={facility.name}
        />
      </InlineParam>
    ))}
  </>
);
